import { createStructuredSelector } from 'reselect';

export const getUsers = (state) => state.users;

export const usersSelector = createStructuredSelector({
    users: getUsers,
});